module.exports = __webpack_public_path__ + "assets/drip.1fef3ee2.svg";